import React, { useEffect, useState } from 'react';
import { useFeatureFlags } from 'hooks';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import { MoreHorizontal, Trash2, Edit3 } from 'react-feather';
import Table from 'components/shared/table';
import Skeleton from 'ui/Skeleton';
import { Text, TEXT_VARIANTS } from 'components/ui/Typography';
import ImagePreview from 'components/shared/ImagePreview';
import { ActionList, IconButton, Popover } from 'components/ui';
import DeleteContentModal from './DeleteContentModal';

/* eslint-disable no-alert */

const NewContentTagTable = () => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [chosenContent, setChosenContent] = useState({});
  const [contentToDelete, setContentToDelete] = useState(false);
  const [contentIdToShowPopoverFor, setContentIdToShowPopoverFor] = useState(0);
  const page = offset / limit + 1;
  const hasEnabledReadinessUnification = useFeatureFlags(
    'readiness-enable-unification',
  );

  useEffect(() => {
    request
      .get(`${routes.TAGS}?page=${page}&per_page=${limit}`)
      .then(result => {
        setTags(result.tags);
        setLoading(false);
        setPageCount(result.totalPages);
      });
  }, [page, limit]);

  async function handleDelete() {
    setContentToDelete(true);
  }

  const closeModal = () => {
    setContentToDelete(false);
  };

  return (
    <div>
      <Table
        className="GradingStationTable Index-table--multipleHeaders mb-32 bg-white border border-gray-light"
        alternate
        noBorderTop
        roundedBottom
      >
        <Table.Header>
          <Table.Header.Cell className="Table-cell--small Table-cell--clickable Table-cell--sortable">
            <div className="d-f fd-r ai-c">
              <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
                {t('tags.table.content_name')}
              </Text>
            </div>
          </Table.Header.Cell>
          <Table.Header.Cell className="Table-cell--small">
            <div className="d-f fd-r ai-c">
              <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
                {t('learn.tag_title')}
              </Text>
            </div>
          </Table.Header.Cell>
          <Table.Header.Cell>
            <div className="d-f fd-r ai-c">
              <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
                {t('tags.table.cover_photo')}
              </Text>
            </div>
          </Table.Header.Cell>
          <Table.Header.Cell className="Table-cell--large">
            <div className="d-f fd-r ai-c">
              <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
                {t('tags.table.description')}
              </Text>
            </div>
          </Table.Header.Cell>
          <Table.Header.Cell className="Table-cell--xSmall" />
        </Table.Header>
        {loading
          ? [...Array(10)].map((e, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.Row key={`loading-row-${i}`}>
                <Table.BodyCell className="Table-cell--xLarge">
                  <Skeleton width={100 * Math.random() + 250} />
                </Table.BodyCell>
                <Table.BodyCell className="Table-cell--small">
                  {Math.random() > 0.2 && <Skeleton />}
                </Table.BodyCell>
                <Table.BodyCell className="Table-cell--xSmall">
                  <Skeleton width={30} />
                </Table.BodyCell>
              </Table.Row>
            ))
          : tags?.map(tag => (
              <Table.Row className="Table-cell--clickable" key={tag?.id}>
                <Table.BodyCell className="Table-cell--small pl-24 border-right-0">
                  {tag.name}
                </Table.BodyCell>
                <Table.BodyCell className="Table-cell--small pl-24 border-right-0">
                  {t(
                    `tags.${
                      hasEnabledReadinessUnification ? 'explore' : 'learn'
                    }.${tag.library_visibility}`,
                  )}
                </Table.BodyCell>
                <Table.BodyCell className="pl-24 border-right-0">
                  {tag.image ? (
                    <ImagePreview className="d-f" image={tag.image} />
                  ) : (
                    '-'
                  )}
                </Table.BodyCell>
                <Table.BodyCell className="Table-cell--large pl-24 border-right-0">
                  {tag.description}
                </Table.BodyCell>
                <Table.BodyCell className="Table-cell--xSmall">
                  <Popover
                    className="AppSwitcher-popover bdrs-4 f-o-n"
                    visible={contentIdToShowPopoverFor === tag.id}
                    onClose={() => setContentIdToShowPopoverFor(0)}
                    activator={
                      <div className="icon">
                        <IconButton
                          onClick={() => {
                            setChosenContent({
                              id: tag.id,
                              name: tag.name,
                            });
                            setContentIdToShowPopoverFor(tag.id);
                          }}
                        >
                          <MoreHorizontal className="Icon--medium c-gray-darker" />
                        </IconButton>
                      </div>
                    }
                  >
                    <ActionList
                      items={[
                        {
                          content: (
                            <>
                              <Edit3
                                name="delete"
                                size={18}
                                className="d-f ai-c mr-10"
                              />
                              <Text variant={TEXT_VARIANTS.BODY}>
                                <a href={routes.TAGS_EDIT(tag.id)}>
                                  {t('tags.edit_content')}
                                </a>
                              </Text>
                            </>
                          ),
                          onClick: () => {
                            setChosenContent({
                              id: tag.id,
                              name: tag.name,
                            });
                          },
                        },
                        {
                          content: (
                            <>
                              <Trash2
                                name="delete"
                                size={18}
                                className="c-red d-f ai-c mr-10"
                              />
                              <Text variant={TEXT_VARIANTS.BODY}>
                                {t('tags.delete_tag')}
                              </Text>
                            </>
                          ),
                          onClick: () => {
                            handleDelete();
                            setContentIdToShowPopoverFor(0);
                          },
                        },
                      ]}
                    />
                  </Popover>
                </Table.BodyCell>
              </Table.Row>
            ))}
        <Table.Footer className="p-12 border border-gray-light">
          <Table.Pagination
            onPageChange={e => setOffset((e - 1) * 10)}
            page={page}
            pageCount={pageCount}
            perPage={limit}
            onPerPageChange={e => {
              setLimit(e);
              setOffset(0);
            }}
          />
        </Table.Footer>
      </Table>
      {contentToDelete && (
        <DeleteContentModal
          closeModal={closeModal}
          contentId={chosenContent.id}
          tags={tags}
          tagName={chosenContent.name}
          setTags={setTags}
        />
      )}
    </div>
  );
};

export default props => <NewContentTagTable {...props} />;
